/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vault_1Inputs */

const en_vault_1 = /** @type {(inputs: Vault_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault`)
};

const es_vault_1 = /** @type {(inputs: Vault_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bóveda`)
};

const fr_vault_1 = /** @type {(inputs: Vault_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coffre-fort`)
};

const de_vault_1 = /** @type {(inputs: Vault_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault`)
};

const ja_vault_1 = /** @type {(inputs: Vault_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保管庫`)
};

const zh_vault_1 = /** @type {(inputs: Vault_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`金库`)
};

const ar_vault_1 = /** @type {(inputs: Vault_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الخزنة`)
};

const id_vault_1 = /** @type {(inputs: Vault_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault`)
};

const it_vault_1 = /** @type {(inputs: Vault_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault`)
};

const ru_vault_1 = /** @type {(inputs: Vault_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хранилище`)
};

const pt_vault_1 = /** @type {(inputs: Vault_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cofre`)
};

const ko_vault_1 = /** @type {(inputs: Vault_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`보관소(Vault)`)
};

/**
* | output |
* | --- |
* | "Vault" |
*
* @param {Vault_1Inputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const vault_1 = /** @type {((inputs?: Vault_1Inputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vault_1Inputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vault_1(inputs)
	if (locale === "es") return es_vault_1(inputs)
	if (locale === "fr") return fr_vault_1(inputs)
	if (locale === "de") return de_vault_1(inputs)
	if (locale === "ja") return ja_vault_1(inputs)
	if (locale === "zh") return zh_vault_1(inputs)
	if (locale === "ar") return ar_vault_1(inputs)
	if (locale === "id") return id_vault_1(inputs)
	if (locale === "it") return it_vault_1(inputs)
	if (locale === "ru") return ru_vault_1(inputs)
	if (locale === "pt") return pt_vault_1(inputs)
	return ko_vault_1(inputs)
});